import { render, staticRenderFns } from "./BulkDossierDownloadButton.vue?vue&type=template&id=82ecf93e&scoped=true"
import script from "./BulkDossierDownloadButton.vue?vue&type=script&setup=true&lang=ts"
export * from "./BulkDossierDownloadButton.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82ecf93e",
  null
  
)

export default component.exports